import { render, staticRenderFns } from "./taskClaim.vue?vue&type=template&id=2028c467&scoped=true"
import script from "./taskClaim.vue?vue&type=script&lang=js"
export * from "./taskClaim.vue?vue&type=script&lang=js"
import style0 from "./taskClaim.vue?vue&type=style&index=0&id=2028c467&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028c467",
  null
  
)

export default component.exports